import {IComponentOptions} from 'angular';
import DateUtil from '../../../utils/DateUtil';
import moment from 'moment';
import ITranslateService = angular.translate.ITranslateService;
import ILogService = angular.ILogService;
import IFilterService = angular.IFilterService;
import IAttributes = angular.IAttributes;

let template = require('./dv-bisher.html');

/**
 * Verwendung:
 * - gs: Wert, den der Gesuchsteller eingegeben hat
 * - fs: Wert, der von fondssuisse angepasst wurde
 *
 * Attribute fuer Eingaben-Blocks (zusammengehoerende Felder):
 * - specificBisherText: Falls einfach der GS-Wert als Bisher angezeigt werden soll. Z.B. Checkbox "Fachstelle": Wir
 *      wollen als Bisher-Text nicht "Fs", sondern "Fachstelle X, mit 50%, vom 01.01.2015 bis 31.12.2015"
 * - blockExisted: Gibt an, ob der Block ueberhaupt vom GS ausgefuellt wurde. Falls nein, muss *jede* Eingabe von FS
 *      als Korrektur angezeigt werden
 * - showIfBisherNone: Zeigt, ob "Keine Eingabe" angezeigt werden soll, wenn es keinen Bisher-Wert
 *      gibt. Normalerweise wollen wir das. Ausnahme sind Blocks, wo wir das "Keine Eingabe" *pro Block* anzeigen wollen
 *      und nicht unter jedem Feld.
 */
export class DvBisherComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        gs: '<',
        fs: '<',
        errorObject: '<for',
        specificBisherText: '<?',
        prefix: '<?',
        decimal: '<?',
        unit: '@?',
        blockExisted: '<?',
        showIfBisherNone: '<?',
        property: '@',
    };
    template = template;
    controller = DvBisherController;
    controllerAs = 'vm';
}

export class DvBisherController {

    static $inject = ['$translate', '$log', '$filter', '$attrs'];

    gs: any;
    fs: any;
    showIfBisherNone: boolean;  // sollen die korrekturen des jugendamts angezeigt werden wenn im GS container kein
                                // wert ist
    specificBisherText: string;
    prefix: string;
    decimal: number;
    unit: string;
    bisherText: Array<string>;
    blockExisted: boolean;
    hasMargin: boolean;
    property: any;
    GSContainerDefined: boolean;
    FSContainerDefined: boolean;
    propertyDefined: boolean;
    forcestring: boolean;
    forcefloor: boolean;
    isTextarea: boolean;

    /* @ngInject */
    constructor(private $translate: ITranslateService,
                private $log: ILogService, private $filter: IFilterService, private $attrs: IAttributes) {

    }

    $onInit() {
        this.hasMargin = 'hasMargin' in this.$attrs;
        this.forcestring = 'forcestring' in this.$attrs;
        this.isTextarea = 'textarea' in this.$attrs;
        this.forcefloor = 'forcefloor' in this.$attrs;
        if (this.showIfBisherNone === undefined) {//wenn nicht von aussen gesetzt auf true
            this.showIfBisherNone = true;
        }
        this.GSContainerDefined = this.gs !== undefined;
        this.FSContainerDefined = this.fs !== undefined;
        this.propertyDefined = this.property !== undefined;

        if (this.GSContainerDefined && this.propertyDefined) {
            if (Object.getOwnPropertyNames(this.gs).indexOf('_' + this.property) < 0) {
                this.$log.error('dv-bisher error \nproperty: "' + this.property + '" doesn\'t exist on container');
            }
        } else {
            this.$log.debug('dv-bisher error \nproperty: ' + this.property + '\ncontainer: ' + this.gs);
        }
    }

    public getBisher(): Array<string> {
        switch (true) {
            case this.specificBisherText !== undefined:
                this.bisherText = this.specificBisherText ? this.specificBisherText.split('\n') : [''];
                return this.hasBisher() ? this.bisherText : [this.$translate.instant('LABEL_KEINE_ANGABE')];
            case this.getGSProperty() instanceof moment:
                let tmpTime = DateUtil.momentToLocalDateFormat(this.getGSProperty(), 'DD.MM.YYYY');
                return tmpTime === undefined ? [''] : [tmpTime];
            case this.getGSProperty() === true:
                return [this.$translate.instant('LABEL_JA')];
            case this.getGSProperty() === false:
                return [this.$translate.instant('LABEL_NEIN')];
            case !this.hasBisher():
                return [this.$translate.instant('LABEL_KEINE_ANGABE')];
            case (this.isNumber(this.getGSProperty()) && !this.forcestring):
                this.decimal = ((this.forcefloor && Math.floor(this.getGSProperty()) === this.getGSProperty()) ? 0 : this.decimal);
                return [this.$filter('number')(this.getGSProperty(), (this.decimal === undefined ? 2 : this.decimal)) + (this.unit === undefined ? '' : this.unit)];
            default:
                return [this.$translate.instant((this.prefix === undefined ? '' : this.prefix) + this.getGSProperty())];
        }
    }

    public isNumber(n: any): boolean {
        return isFinite(n) && +n === n;
    };

    public hasBisher(): boolean {
        return !this.isEmpty(this.getGSProperty());
    }

    public showBisher(): boolean {
        if (this.GSContainerDefined) {
            return ((this.showIfBisherNone || this.blockExisted === true) || this.hasBisher());
        } else {
            return false;
        }
    }

    public equals(gs: any, fs: any): boolean {
        if (gs instanceof moment) {
            return this.equals(DateUtil.momentToLocalDateFormat(gs, 'DD.MM.YYYY'), DateUtil.momentToLocalDateFormat(fs, 'DD.MM.YYYY'));
        }
        return gs === fs || (this.isEmpty(gs) && this.isEmpty(fs)); //either they are equal or both are a form of empty
    }

    public getGSProperty(): any {
        if (this.GSContainerDefined && this.propertyDefined) {
            return this.gs[this.property];
        } else {
            return null;
        }
    }

    public getFSProperty(): any {
        if (this.FSContainerDefined && this.propertyDefined) {
            return this.fs[this.property];
        } else {
            return null;
        }
    }

    private isEmpty(val: any): boolean {
        return val === undefined || val === null || val === '';
    }
}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-bisher/dv-bisher.ts